// TaskBoard.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DragDropContext } from 'react-beautiful-dnd';
import dayjs from 'dayjs';
import TaskColumn from './taskcolumn.js'
import './taskboard.css';
import axiosInstance from '../../services/AxiosInstance.js';
import { formatDateToDDMMMYYYY } from '../../utils/dateFormatter';

const TaskBoard = () => {
  const [tasks, setTasks] = useState([]);
  const [groupedTasks, setGroupedTasks] = useState({});
   

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
      const user=JSON.parse(localStorage.getItem('user'))
      console.log("user",user)
       const queryParams = new URLSearchParams();

    if (user.id !== '') queryParams.append('CorporateUserId', user.id);
    try {
       const response = await axiosInstance.get(`/task/list?${queryParams.toString()}`);
       console.log("filtered",response)
        if (!response) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json(); 
        console.log("result",result)
      setTasks(result.tasks);
    } catch (error) {
      console.error('Failed to fetch tasks:', error);
    }
  };

  useEffect(() => {
    groupTasksByDeadline(tasks);
  }, [tasks]);
const formatDateWithSuffix = (dateString) => {
  return formatDateToDDMMMYYYY(dateString);
};
  const groupTasksByDeadline = (tasks) => {
    const today = dayjs();
    const groups = {
      'Overdue': [],
      'Due today': [],
      'Due this week': [],
      'Due next week': [],
      'No deadline': []
    };
    console.log("tasks",tasks)
    tasks.forEach(task => {
      if (!task.EndDate) {
        groups['No deadline'].push(task);
        return;
      }
      
      const deadline = dayjs(task.EndDate);
      if (deadline.isBefore(today, 'day')) groups['Overdue'].push(task);
      else if (deadline.isSame(today, 'day')) groups['Due today'].push(task);
      else if (deadline.diff(today, 'day') <= 7) groups['Due this week'].push(task);
      else groups['Due next week'].push(task);
    });

    setGroupedTasks(groups);
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    const sourceCol = Object.keys(groupedTasks)[source.droppableId];
    const destCol = Object.keys(groupedTasks)[destination.droppableId];

    const sourceTasks = Array.from(groupedTasks[sourceCol]);
    const destTasks = Array.from(groupedTasks[destCol]);

    const [movedTask] = sourceTasks.splice(source.index, 1);
    destTasks.splice(destination.index, 0, movedTask);

    setGroupedTasks({
      ...groupedTasks,
      [sourceCol]: sourceTasks,
      [destCol]: destTasks
    });
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="task-board">
        {Object.entries(groupedTasks).map(([status, taskList], index) => (
          <TaskColumn key={status} status={status} tasks={taskList} columnId={index.toString()} />
        ))}
      </div>
    </DragDropContext>
  );
};

export default TaskBoard;
